
















import Vue from 'vue'

export default Vue.extend({
  name: 'CancelButton',
  props: {
    text: { type: Boolean, default: false },
  },
})
